import { TEventsPrimary } from '../../apis/events/events.interfaces';

// Indian names
const indianNames = [
  'Ramesh Agarwal', 'Priya Sharma', 'Arjun Kumar', 'Anjali Patel', 'Vikram Singh',
  'Kavita Reddy', 'Rajesh Mehta', 'Meera Iyer', 'Amit Gupta', 'Sunita Joshi',
  'Suresh Nair', 'Neha Rao', 'Karan Desai', 'Radha Shah', 'Anil Verma',
  'Shreya Agarwal', 'Manoj Sharma', 'Divya Patel', 'Deepak Kumar', 'Pooja Singh',
  'Ravi Reddy', 'Kiran Mehta', 'Nisha Gupta', 'Sandeep Joshi', 'Uma Iyer',
  'Gopal Nair', 'Lakshmi Rao', 'Venkat Desai', 'Sarita Shah', 'Rohit Verma',
];

const indianCities = ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 'Hyderabad', 'Pune', 'Ahmedabad', 'Jaipur', 'Surat'];
const indianStates = ['Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'West Bengal', 'Telangana', 'Gujarat', 'Rajasthan'];
const indianPinCodes = ['400001', '110001', '560001', '600001', '700001', '500001', '411001', '380001', '302001', '395001'];

const eventTitles = [
  'Annual Science Exhibition', 'Cultural Fest 2025', 'Robotics Workshop', 'Mathematics Olympiad',
  'Debate Competition', 'Sports Day', 'Art Exhibition', 'Music Concert', 'Dance Performance',
  'Science Fair', 'Tech Hackathon', 'Literary Festival', 'Career Guidance Session', 'Health Awareness Camp',
  'Environmental Awareness Program', 'Career Fair', 'Inter-School Competition', 'Quiz Competition',
  'Photography Contest', 'Drama Festival', 'Yoga Workshop', 'Meditation Session', 'Book Fair',
  'Career Counseling', 'Parent-Teacher Meeting', 'Graduation Ceremony', 'Award Ceremony',
  'Independence Day Celebration', 'Republic Day Parade', 'Diwali Celebration', 'Holi Festival',
  'Annual Day Function', 'Farewell Party', 'Welcome Party', 'Teachers Day Celebration',
  'Children Day Celebration', 'Gandhi Jayanti', 'Eco Club Activity', 'Science Club Workshop',
  'Math Club Competition', 'English Literary Club', 'Computer Club Hackathon', 'Sports Club Tournament',
  'Music Club Concert', 'Dance Club Performance', 'Drama Club Show', 'Art Club Exhibition',
  'Photography Club Contest', 'Debate Club Competition', 'Quiz Club Championship', 'Chess Tournament',
];

const eventGroups = ['technical', 'cultural', 'sports', 'academic', 'social', 'other'];
const eventScopes = ['student', 'staff', 'parent', 'all'];
const eventStatuses = ['scheduled', 'completed', 'cancelled', 'postponed'];
const priorities = ['low', 'medium', 'high'];
const venues = [
  'Main Auditorium', 'Open Grounds', 'Innovation Lab', 'Exhibition Hall', 'Sports Complex',
  'Conference Room', 'Library Hall', 'Amphitheater', 'Indoor Stadium', 'Outdoor Stadium',
  'Science Lab', 'Computer Lab', 'Art Room', 'Music Room', 'Dance Studio',
];

const instituteNames = [
  'Delhi Public School', 'Kendriya Vidyalaya', 'D.A.V. Public School', 'Ryan International School',
  'Amity International School', 'Modern School', 'St. Xavier\'s School', 'Loyola School',
  'Bharatiya Vidya Bhavan', 'Sanskriti School', 'Vasant Valley School', 'The Doon School',
  'Mayo College', 'Welham Boys School', 'Welham Girls School', 'The Scindia School',
  'La Martiniere School', 'St. Stephen\'s School', 'Mount Carmel School', 'St. Mary\'s School',
];

function generateEvent(index: number): TEventsPrimary {
  // Calculate day of February (0-27) and event index within day (0-2)
  const dayOfMonth = Math.floor(index / 3);
  const eventInDay = index % 3;

  const nameIndex = index % indianNames.length;
  const cityIndex = index % indianCities.length;
  const stateIndex = index % indianStates.length;
  const pinIndex = index % indianPinCodes.length;
  const instituteIndex = index % instituteNames.length;

  const managerName = indianNames[nameIndex];
  const firstName = managerName.split(' ')[0].toLowerCase();
  const lastName = managerName.split(' ')[1]?.toLowerCase() || '';
  const userName = `${firstName}${lastName ? lastName[0] : ''}$${String(index + 1).padStart(3, '0')}`;

  const eventGroup = eventGroups[index % eventGroups.length];
  const eventScope = eventScopes[index % eventScopes.length] as any;
  const status = eventStatuses[index % eventStatuses.length] as any;
  const priority = priorities[index % priorities.length] as any;
  const venue = venues[index % venues.length];
  const title = eventTitles[index % eventTitles.length];

  const baseDate = new Date('2026-02-01');
  const startDate = new Date(baseDate.getTime() + dayOfMonth * 24 * 60 * 60 * 1000);
  // Add hours to spread events throughout the day (morning, afternoon, evening)
  startDate.setHours(9 + eventInDay * 5, eventInDay * 15, 0, 0);
  const endDate = new Date(startDate.getTime() + (index % 3 + 1) * 24 * 60 * 60 * 1000);

  const expenditureEstimate = (index % 10 + 1) * 5000;
  const expenditureActual = status === 'completed' ? expenditureEstimate * (0.8 + Math.random() * 0.2) : undefined;

  const managerId = `m${String(index + 1).padStart(3, '0')}a1b2-c3d4-4e5f-8a1b-2c3d4e5f6a7b`;
  const instituteId = `i${String(index + 1).padStart(3, '0')}j2k3-l4m5-4n6o-9p7q-3r4s5t6u7v8w`;
  const addressId = `a${String(index + 1).padStart(3, '0')}b2c3-d4e5-4f6a-8b1c-2d3e4f5a6b7c`;
  const contactId = `c${String(index + 1).padStart(3, '0')}d2e3-4f5a-4971-8464-b1509e2e8f01`;

  const phoneNumber = `9${String(index).padStart(9, '0')}`.slice(0, 10);

  const staffAssignmentsCount = (index % 3) + 1;
  const staffAssignments = Array.from({ length: staffAssignmentsCount }, (_, i) => {
    const staffIndex = (index + i) % indianNames.length;
    const staffName = indianNames[staffIndex];
    const staffFirstName = staffName.split(' ')[0].toLowerCase();
    const staffLastName = staffName.split(' ')[1]?.toLowerCase() || '';
    return {
      id: `s${String(index + 1).padStart(3, '0')}${String(i + 1).padStart(2, '0')}a1b2-c3d4-4e5f-8a1b-2c3d4e5f6a7b`,
      name: staffName,
      email: `${staffFirstName}.${staffLastName}@institute.edu`,
      eventRole: ['Technical Coordinator', 'Logistics Manager', 'Cultural Coordinator', 'Event Manager', 'Support Staff'][i % 5],
      responsibilities: [
        ['Equipment setup', 'Technical support'],
        ['Venue arrangement', 'Catering'],
        ['Stage management', 'Performance scheduling'],
        ['Registration', 'Coordination'],
        ['Security', 'Cleanup'],
      ][i % 5],
    };
  });

  const participantsCount = (index % 5) + 2;
  const participants = Array.from({ length: participantsCount }, (_, i) => ({
    id: `p${String(index + 1).padStart(3, '0')}${String(i + 1).padStart(2, '0')}a1b2-c3d4-4e5f-8a1b-2c3d4e5f6a7b`,
    type: (i % 2 === 0 ? 'student' : 'staff') as any,
    status: (['confirmed', 'tentative', 'cancelled'][i % 3]) as any,
    attendanceStatus: (['present', 'absent', 'tentative'][i % 3]) as any,
  }));

  const relatedClass = index % 3 === 0 ? {
    grade: String((index % 12) + 1),
    section: String.fromCharCode(65 + (index % 5)),
  } : undefined;

  return {
    id: `e${String(index + 1).padStart(3, '0')}d1f1-1a2b-4c3d-8a1e-1f1a2b3c4d5e`,
    title,
    status,
    venue,
    manager: {
      _id: managerId,
      name: managerName,
      userRole: index % 2 === 0 ? 'internal_staff' : 'faculty',
      userName,
      createdAt: new Date(startDate.getTime() - 30 * 24 * 60 * 60 * 1000),
    },
    description: `${title} organized by ${instituteNames[instituteIndex]}. This event aims to provide students with valuable learning experiences and opportunities.`,
    startDate,
    endDate,
    eventGroup: eventGroup as any,
    eventScope: eventScope as any,
    expenditureActual: expenditureActual || 0,
    expenditureEstimate,
    institute: {
      _id: instituteId,
      name: instituteNames[instituteIndex],
      address: {
        _id: addressId,
        street1: `${(index % 100) + 1} ${indianCities[cityIndex]} Road`,
        street2: index % 3 === 0 ? `Block ${String.fromCharCode(65 + (index % 5))}` : '',
        city: indianCities[cityIndex],
        state: indianStates[stateIndex],
        pinCode: indianPinCodes[pinIndex],
        isCurrent: true,
        description: 'Main Campus',
      },
      contact: {
        _id: contactId,
        phone: {
          country_code: '+91',
          phone_number: phoneNumber,
          is_verified: index % 2 === 0,
        },
        email: {
          email: `contact@${firstName}institute.edu`,
          is_verified: true,
        },
      },
      createdAt: new Date(startDate.getTime() - 365 * 24 * 60 * 60 * 1000),
    },
    plannedBy: {
      _id: managerId,
      name: managerName,
      userRole: index % 2 === 0 ? 'internal_staff' : 'faculty',
      userName,
      createdAt: new Date(startDate.getTime() - 30 * 24 * 60 * 60 * 1000),
    },
    purpose: `To provide students with valuable learning experiences and foster ${eventGroup} skills through ${title.toLowerCase()}.`,
    remarks: index % 2 === 0 ? 'Registration required. Limited seats available.' : 'Open to all participants. Volunteers welcome.',
    participants,
    staffAssignments,
    isMandatory: index % 4 === 0,
    priority,
    relatedClass,
  };
}

export const mockEventsList: TEventsPrimary[] = Array.from({ length: 84 }, (_, i) => generateEvent(i));
